'use strict';

angular.module('selfAccessRequestRoutes', [
    'services.selfAccessRequest',
    'selfAccessRequestControllers',
    'selfAccessRequestControllers.Arrival',
    'services.businessSystem',
    'services.systemOwnerReview'
])

.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {

    $stateProvider

        .state('selfAccessRequest', {
             url: '/SelfAccessRequest/{userAccessRequestId}',
             templateUrl: require('./SelfAccessRequest.tpl.html'),
             controller: 'SelfAccessRequestController',
             resolve: {
                 authUser: ['authenticatedUserService', function (service) {
                     return service.getAuthenticatedUser();
                 }],
                 empIdentity: ['employeeService', function (service) {
                     return service.getEmployeeIDByAuthentication();
                 }],
                 selfAccessRequest: ['selfAccessRequestService', '$stateParams', function (service, $stateParams) {
                     return service.getSelfAccessRequest($stateParams.userAccessRequestId);
                 }],
                 processStepsByStepName: ['selfAccessRequest', function (selfAccessRequest) {
                     return _.groupBy(selfAccessRequest.ProcessStepStatusList, 'Step');
                 }],
                 lookUps: ['selfAccessRequestService', function (selfAccessRequestService) {
                     return selfAccessRequestService.getSelfAccessRequestLookups();
                 }],
                 decisionLookUpsById: ['lookUps', function (lookUps) {
                     var byId = _.chain(lookUps.ProgressStepDecisions)
                                 .groupBy('SelfAccessRequestProcessStepDecisionID')
                                 .mapValues(function (byId) {
                                     return byId[0];
                                 })
                                 .value();
                     return byId;
                 }]
             }
         })

         .state('selfAccessRequest.noLongerSelfRequest', {
             url: '/NoLongerSelfAccessRequest',
             views: {
                 '': {
                     templateUrl: require('./noLongerSelfAccessRequest.tpl.html'),
                 }
             },
         })

          .state('selfAccessRequest.ownedByOtherUser', {
              url: '/OwnedByOtherUser',
              views: {
                  '': {
                      templateUrl: require('./ownedByOtherUser.tpl.html'),
                  }
              },
          })



}]);
